var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "separable" }, [
    _c(
      "div",
      { staticClass: "marginTop container" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 24 } }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header titulo" }, [
                  _vm._v("Central de comunicações")
                ]),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("p", { staticClass: "bold" }, [
                      _vm._v("Listagem de conversas")
                    ]),
                    _c("el-row", [_c("div", { staticClass: "divider" })]),
                    _c(
                      "div",
                      { staticClass: "table-pointer" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { cursor: "pointer" },
                            attrs: {
                              data: _vm.conversas,
                              "default-sort": {
                                prop: "id",
                                order: "descending"
                              }
                            },
                            on: { "sort-change": _vm.sort }
                          },
                          [
                            _c("el-table-column", {
                              attrs: { "min-width": "40" }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Assunto",
                                prop: "assuntoDescricao",
                                "min-width": "300"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Responsável",
                                "min-width": "300",
                                prop:
                                  "mensagemList[0].destinatario.pessoaFisica.nome",
                                formatter: _vm.formatNome
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Data de início da conversa",
                                sortable: "sortable",
                                "min-width": "210",
                                prop: "dataInicioConversa",
                                formatter: _vm.formatDataInicioConversa
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Data da última resposta",
                                sortable: "sortable",
                                "min-width": "210",
                                prop: "dataUltimaMensagem",
                                formatter: _vm.formatDataResposta
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Status",
                                "min-width": "100",
                                prop: "statusDescricao",
                                sortable: "sortable"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Ações",
                                "min-width": "100",
                                prop: "id"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-dropdown",
                                        {
                                          attrs: {
                                            trigger: "click",
                                            size: "small"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini"
                                              }
                                            },
                                            [
                                              _vm._v("Ações"),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-down el-icon--right"
                                              })
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown"
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c("el-dropdown-item", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "flex",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.$router.push(
                                                              {
                                                                name:
                                                                  "VISUALIZAR_CONVERSA_MANUTENCAO",
                                                                params: {
                                                                  idConversa:
                                                                    scope.row.id
                                                                }
                                                              }
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-eye"
                                                        }),
                                                        _vm._v(
                                                          "  Visualizar conversa"
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _c("el-dropdown-item", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "flex",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.encerrarConversaById(
                                                              scope.row.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-check"
                                                        }),
                                                        _vm._v(
                                                          "  Encerrar conversa"
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2009812a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2009812a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/ListagemConversa.vue
// module id = null
// module chunks = 